import { Button, Card, CardBody } from '@heroui/react';
import React from 'react';
import { FiSettings, FiSave } from 'react-icons/fi';

export const SettingsPage: React.FC = () => {
  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-foreground">Settings</h1>
        <Button color="primary" startContent={<FiSave size={16} />}>
          Save Changes
        </Button>
      </div>

      <Card className="text-center">
        <CardBody className="p-12">
          <div className="w-20 h-20 rounded-full bg-default-100 flex items-center justify-center mx-auto mb-6 text-default-600">
            <FiSettings size={40} />
          </div>
          <h2 className="text-2xl font-semibold text-foreground mb-4">
            Admin Settings
          </h2>
          <p className="text-lg text-foreground-500">
            This page will contain system configuration settings, user
            preferences, security settings, and application management options.
          </p>
        </CardBody>
      </Card>
    </div>
  );
};
